import styled from 'styled-components'
import { Colors, Utils } from '@microfrontends/react-components'

export const CareerViewContainer = styled.a<{ isActive?: boolean }>`
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 230px;
	padding: 24px 16px;
	border-radius: 12px;
	transition: background 0.25s ease-in-out, border-radius 0.25s ease-in-out;
	${({ isActive }) =>
		isActive
			? `
    background-color: #d9e6ff;
  `
			: ''}
	&:hover {
		background-color: #d9e6ff;
	}
`

export const IconContainer = styled.div`
	position: relative;
	width: 100px;
	height: 100px;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 12px;
	border: 2px solid ${Colors.primary};
	flex-shrink: 0;
`

export const IconWrapper = styled.div`
  width: 56px;
  height: 56px;
`

export const Text = styled.p`
	font-size: 13px;
	display: flex;
	flex-direction: column;
	text-align: center;
	word-break: inherit;
	color: ${Colors.darkBlue};
	& > .title {
		font-family: 'Dela Gothic One';
		text-transform: uppercase;
		font-size: 13px;
		word-break: inherit;
		margin-bottom: 4px;
		line-height: 19px;
		letter-spacing: 1px;
		word-break: break-word;
		color: ${Colors.darkBlue};
	}
	line-height: 17px;
	margin-bottom: 0;
	@media (max-width: ${Utils.screens.mobile}px) {
		& > .title {
			font-size: 11px;
		}
	}
`
